import { BRAND, waLink } from "@/lib/brand";
import { FaWhatsapp, FaInstagram } from "react-icons/fa";
import { Phone } from "lucide-react";
import { useT } from "@/lib/i18n";

export default function Footer() {
  const { t } = useT();
  return (
    <footer data-testid="site-footer" className="relative bg-[#060E22] border-t border-gold/15 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <div className="h-12 w-12 rounded-full overflow-hidden ring-1 ring-gold/40">
                <img src={BRAND.logoUrl} alt="Unity Real Estate" className="h-full w-full object-cover" />
              </div>
              <div>
                <div className="font-serif text-xl text-white">UNITY</div>
                <div className="text-[10px] tracking-[0.3em] text-gold uppercase">Real Estate</div>
              </div>
            </div>
            <p className="text-slate-400 leading-relaxed max-w-sm">{t("ftr.tag")}</p>
            <div className="mt-6 flex flex-wrap gap-2">
              {BRAND.languages.map((l) => (
                <span key={l} className="text-xs text-gold-light border border-gold/30 rounded-full px-3 py-1">
                  {t(`lang.${l}`)}
                </span>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs tracking-[0.25em] text-gold uppercase mb-4">{t("ftr.explore")}</div>
            <ul className="space-y-3 text-slate-300 text-sm">
              <li><a className="hover:text-gold transition-colors" href="#services">{t("nav.services")}</a></li>
              <li><a className="hover:text-gold transition-colors" href="#pricing">{t("nav.pricing")}</a></li>
              <li><a className="hover:text-gold transition-colors" href="#why">{t("nav.why_us")}</a></li>
              <li><a className="hover:text-gold transition-colors" href="#faq">{t("nav.faq")}</a></li>
              <li><a className="hover:text-gold transition-colors" href="#contact">{t("nav.contact")}</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs tracking-[0.25em] text-gold uppercase mb-4">{t("ftr.contact")}</div>
            <div className="space-y-3">
              <a href={`tel:${BRAND.phoneRaw}`} data-testid="footer-phone" className="flex items-center gap-3 text-white hover:text-gold transition-colors">
                <Phone className="h-4 w-4 text-gold" />
                <span className="font-medium">{BRAND.phone}</span>
              </a>
              <a href={waLink(t("wa.default"))} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="inline-flex items-center gap-2 bg-gold hover:bg-gold-light text-navy-900 font-medium px-5 py-2.5 rounded-full transition-[color,background-color,border-color,box-shadow,transform]">
                <FaWhatsapp className="h-4 w-4" /> {t("ftr.chat")}
              </a>
            </div>
            <div className="mt-6 flex gap-3">
              <a href={waLink(t("wa.default"))} target="_blank" rel="noopener noreferrer" className="h-10 w-10 rounded-full border border-gold/30 text-gold hover:bg-gold hover:text-navy-900 inline-flex items-center justify-center transition-[color,background-color,border-color,box-shadow,transform]" aria-label="WhatsApp">
                <FaWhatsapp className="h-4 w-4" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="h-10 w-10 rounded-full border border-gold/30 text-gold hover:bg-gold hover:text-navy-900 inline-flex items-center justify-center transition-[color,background-color,border-color,box-shadow,transform]" aria-label="Instagram">
                <FaInstagram className="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-gold/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} Unity Real Estate. {t("ftr.rights")}</p>
          <p className="text-xs text-slate-500 font-serif italic">{t("ftr.warsaw")}</p>
        </div>
      </div>
    </footer>
  );
}
